import { Component } from '../component';
import { defineCustomElement } from '../utils';
export class Section extends Component {
    constructor(name) {
        super(name);
        this.handleShopifySectionSelect = this.handleShopifySectionSelect.bind(this);
        this.handleShopifySectionDeselect = this.handleShopifySectionDeselect.bind(this);
        // TODO: Currently each section will handle the event from other sections aswell.
        // We need to find a way to only handle the event from the current section.
        document.addEventListener('shopify:section:select', this.handleShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.handleShopifySectionDeselect);
    }
    handleShopifySectionSelect(event) {
        const eventDetail = event.detail;
        if (eventDetail && this.closest(`#shopify-section-${eventDetail.sectionId}`)) {
            this.onSectionSelect();
        }
    }
    handleShopifySectionDeselect(event) {
        const eventDetail = event.detail;
        if (eventDetail && this.closest(`#shopify-section-${eventDetail.sectionId}`)) {
            this.onSectionDeselect();
        }
    }
    onSectionSelect() { }
    onSectionDeselect() { }
}
/**
 * Defines a custom element.
 */
export function defineSection(name, component) {
    defineCustomElement(name, component);
}
